import { Worker } from '@react-pdf-viewer/core';

const PdfWorker = ({ children }: { children: React.ReactNode }) => {
  return (
    <Worker workerUrl="https://unpkg.com/pdfjs-dist@3.11.174/build/pdf.worker.min.js">
      {children}
    </Worker>
  );
};

export default PdfWorker;
